const addGiftProductToCart = async (variantId, quantity, properties) => {
    const url = '/cart/add.js';
    const data = { id: variantId,quantity: quantity,sections: ['mini-cart'] };
    if (properties) data.properties = properties; // TOVARA: optionale Line-Item-Properties (z.B. _free_product für den Untersetzer)
    try {
        const response = await fetch(url, {
            method: 'POST', 
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        });

        if (!response.ok) {throw new Error('Network response was not ok ' + response.statusText);}

        const responseJson = await response.json();
        console.log('Item added to cart:', responseJson);
        const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
        const cartContent = await cartResponse.json();
        
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: { cart: cartContent }
        }));
        
        cartContent["sections"] = responseJson["sections"];
        console.log('cartContent:', cartContent["sections"]);

        const miniCartStatus = document.querySelector('#mini-cart').getAttribute('open') === '';
        console.log(miniCartStatus);

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart: cartContent, openMiniCart: miniCartStatus }
        }));

        return true;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return false;
    }
};

const removeGiftProduct = async (variantId) => {
    const url = '/cart/update.js';
    const data = {
        id: variantId,
        quantity: 0,
        sections: ['mini-cart']
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        const cart = await response.json();
        console.log('Item removed from cart:', cart);

        return true;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return false;
    }
};
const addInsurance = async (variantId, quantity, url) => {
// const url = '/cart/add.js';
    const data = { id: variantId,quantity: quantity,sections: ['mini-cart'] };
    try {
        const response = await fetch(url, {
            method: 'POST', 
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        });

        if (!response.ok) {throw new Error('Network response was not ok ' + response.statusText);}

        const responseJson = await response.json();
        console.log('Item added to cart:', responseJson);
        const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
        const cartContent = await cartResponse.json();
        
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: { cart: cartContent }
        }));
        
        cartContent["sections"] = responseJson["sections"];
        console.log('cartContent:', cartContent["sections"]);

        const miniCartStatus = document.querySelector('#mini-cart').getAttribute('open') === '';
        console.log(miniCartStatus);

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart: cartContent, openMiniCart: miniCartStatus }
        }));

        return true;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return false;
    }
}

function animateCounter(element, duration) {
  const end = parseInt(element.dataset.value);
  const startTime = performance.now();
  const updateCounter = (currentTime) => {
    const progress = Math.min(
      (currentTime - startTime) / duration,
      1
    );
    element.value = Math.floor(progress * end);
    if (progress < 1) requestAnimationFrame(updateCounter);
  };
  requestAnimationFrame(updateCounter);
}


// TOVARA: Untersetzer auf genau `target` Stück normalisieren (target 1 = eine Zeile à 1;
// target 0 = alle entfernen). Nutzt die Line-Keys aus /cart.js, damit auch mehrere Zeilen
// (z.B. Alt-Warenkorb mit unterschiedlichen Properties) zuverlässig zusammengeführt/entfernt werden.
const normalizeTrivet = async (target) => {
  const TRIVET_VARIANT = 41199249719345;
  try {
    const cart = await (await fetch('/cart.js')).json();
    const lines = cart.items.filter((i) => i.id === TRIVET_VARIANT);
    if (lines.length === 0) { return true; }
    const updates = {};
    lines.forEach((l, idx) => { updates[l.key] = (target === 1 && idx === 0) ? 1 : 0; });
    const res = await fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: ['mini-cart'] })
    });
    if (!res.ok) { console.error('normalizeTrivet update failed:', res.status); return false; } // kein cart:refresh bei Fehler -> kein Re-Fire
    const data = await res.json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: data } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: data } }));
    return true;
  } catch (e) { console.error('normalizeTrivet:', e); return false; }
};

// TOVARA: Glasdeckel (41199249686577) = genau 1 pro Pfanne — zentral rekonziliert.
// Zielzustand je Pfannen-Produktgruppe: EINE Glasdeckel-Zeile mit _product_id = <Pfannen-Produkt-ID>
// und Menge = Summe aller Pfannen-Zeilen dieses Produkts (M/L/Wok sind Varianten desselben Produkts).
// Gruppe ohne Pfanne -> ihre Glasdeckel-Zeile raus. Gruppe mit Pfanne, aber ohne Zeile -> nachlegen.
// Herrenlose Glasdeckel-Zeilen (ohne/mit falscher _product_id, z.B. Alt-Warenkorb oder Race) werden
// ins Ziel eingefaltet, damit die GESAMT-Glasdeckelmenge immer der Gesamt-Pfannenmenge entspricht.
// Geschrieben wird NUR, wenn Ist != Ziel -> keine Endlosschleife. Pro Durchlauf genau EIN Schreib-
// vorgang (erst Mengen-Update; ein noch fehlender Add folgt im naechsten Durchlauf via cart:refresh),
// darum konvergiert der Warenkorb nach spaetestens zwei Durchlaeufen. In-Flight-Guard gegen Races
// mit dem Per-Klick-Abgleich in theme.js (_updateFromLink) — beide zielen auf denselben Sollwert.
const GLASDECKEL_VARIANT = 41199249686577;
const GLASDECKEL_PAN_PRODUCT_IDS = ['7186055954481']; // TOVARA US 2026-08-29: nur die US-Pfanne; DE-Sonderpfannen (B-Ware, 2+1, GWP) existieren hier nicht

const normalizeGlasdeckel = async (retry) => {
  retry = retry || 0;
  if (window.__tovGlasdeckelPending) { return true; }
  try {
    const cart = await (await fetch('/cart.js')).json();

    // Pfannenmenge je Produktgruppe. product_id aus /cart.js statt der _product_id-Property ->
    // greift unabhaengig davon, wie die Pfanne in den Warenkorb kam.
    const panQty = {};
    GLASDECKEL_PAN_PRODUCT_IDS.forEach((p) => { panQty[p] = 0; });
    cart.items.forEach((i) => {
      const pid = String(i.product_id);
      if (Object.prototype.hasOwnProperty.call(panQty, pid)) { panQty[pid] += i.quantity; }
    });

    const lidLines = cart.items.filter((i) => i.id === GLASDECKEL_VARIANT);
    const groups = GLASDECKEL_PAN_PRODUCT_IDS.filter((p) => panQty[p] > 0);

    // Zeilen den Gruppen zuordnen: erst per passender _product_id, dann herrenlose Zeilen einfalten.
    const taken = {}, assigned = {};
    groups.forEach((g) => {
      const m = lidLines.find((l) => !taken[l.key] && String(l.properties && l.properties._product_id) === g);
      if (m) { taken[m.key] = true; assigned[g] = m; }
    });
    groups.forEach((g) => {
      if (assigned[g]) { return; }
      const m = lidLines.find((l) => !taken[l.key]);
      if (m) { taken[m.key] = true; assigned[g] = m; }
    });

    // Sollmenge je vorhandener Zeile (nicht zugeordnete Zeilen -> 0 = entfernen).
    const updates = {};
    let changed = false;
    lidLines.forEach((l) => {
      let target = 0;
      groups.forEach((g) => { if (assigned[g] && assigned[g].key === l.key) { target = panQty[g]; } });
      updates[l.key] = target;
      if (l.quantity !== target) { changed = true; }
    });

    if (changed) {
      window.__tovGlasdeckelPending = true;
      const res = await fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: ['mini-cart'] })
      });
      window.__tovGlasdeckelPending = false;
      if (!res.ok) {
        // 422 heisst praktisch immer: eine Zielzeile ist zwischenzeitlich verschwunden, weil der
        // Per-Klick-Abgleich in theme.js parallel geschrieben hat. Einmal mit frischen Line-Keys
        // nachfassen; danach aufgeben (das naechste cart:refresh raeumt ohnehin nach).
        console.error('normalizeGlasdeckel update failed:', res.status);
        if (retry < 1) { return await normalizeGlasdeckel(retry + 1); }
        return false; // kein cart:refresh bei Fehler -> kein Re-Fire
      }
      const data = await res.json();
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: data } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: data } }));
      console.log('Glasdeckel auf Pfannenmenge normalisiert:', updates);
      return 'changed';
    }

    // Mengen stimmen -> fehlt einer Gruppe die Zeile komplett, jetzt nachlegen.
    // Eigener Add (statt addGiftProductToCart), weil dessen #mini-cart-Zugriff auf der
    // /cart-Seite ins Leere laeuft; Events werden hier defensiv gefeuert.
    const missing = groups.filter((g) => !assigned[g]);
    if (missing.length > 0) {
      const g = missing[0];
      window.__tovGlasdeckelPending = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: GLASDECKEL_VARIANT, quantity: panQty[g],
            properties: { _free_product: 'true', _product_id: g },
            sections: ['mini-cart']
          })
        });
        window.__tovGlasdeckelPending = false;
        if (!res.ok) { console.error('normalizeGlasdeckel add failed:', res.status); return false; }
        const added = await res.json();
        const cartAfter = await (await fetch('/cart.js')).json();
        cartAfter['sections'] = added['sections'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartAfter } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartAfter } }));
        console.log('Glasdeckel nachgelegt fuer Produkt', g, 'Menge', panQty[g]);
        return 'changed';
      } catch (e) { window.__tovGlasdeckelPending = false; console.error('normalizeGlasdeckel add:', e); return false; }
    }

    return true;
  } catch (e) {
    window.__tovGlasdeckelPending = false;
    console.error('normalizeGlasdeckel:', e);
    return false;
  }
};

const checkFreeGifts = (html) => {
    const freeGiftCircles = html.querySelectorAll('.rewardbar .rewardbar-freegift-circle');
    const cartProductItems = html.querySelectorAll('.drawer__content .line-item .product-item-meta__title');
    const activeCircle = Array.from(freeGiftCircles).find(circle => circle.classList.contains('active'));
    const dataProductValues = Array.from(freeGiftCircles).map(circle => circle.getAttribute('data-product')).filter(Boolean);
    const insurance_product = html.querySelector('.line-item[data-id="41199244935217"]');
    const cart_items =  document.querySelectorAll('.line-item.main-items').length;
    if(!insurance_product && cart_items > 0){
       addInsurance('41199244935217', 1,'/cart/add.js').then((added) => {
                console.log('Added: ', added);
            });
    }
    if(cart_items == 0 && insurance_product){
        addInsurance('41199244935217', 0,'/cart/change.js').then((removed) => {
                console.log('removed: ', removed);
            });
    }

    // TOVARA: Bambus-Untersetzer = genau 1x pro Bestellung (nicht pro Pfanne).
    // Liegt >=1 Pfanne im Warenkorb -> genau 1 Untersetzer sicherstellen; keine Pfanne -> entfernen;
    // >1 Stück oder mehrere Zeilen (Alt-Warenkorb/Race) -> auf genau 1 Zeile à 1 normalisieren.
    // Der Glasdeckel skaliert weiter pro Pfanne (Logik in theme.js).
    (function () {
      var TRIVET = '41199249719345';
      var PAN_IDS = ['7186055954481']; // TOVARA US 2026-08-29
      var panLines = Array.from(html.querySelectorAll('.line-item[data-free-add="true"]'))
        .filter(function (l) { return PAN_IDS.indexOf(l.getAttribute('data-free-added-id')) !== -1; });
      var trivetLines = Array.from(html.querySelectorAll('.line-item[data-id="' + TRIVET + '"]'));
      var trivetQty = trivetLines.reduce(function (sum, l) {
        var i = l.querySelector('input[name="updates[]"]');
        return sum + (i ? (parseInt(i.value) || 0) : 1);
      }, 0);
      if (panLines.length > 0 && trivetLines.length === 0) {
        // Pfanne da, aber kein Untersetzer (z.B. Alt-Warenkorb oder vom Kunden entfernt) -> genau 1 anlegen.
        // In-Flight-Guard verhindert einen zweiten Add, solange der erste noch läuft (Race + doppeltes cart:refresh).
        if (window.__tovTrivetPending) { return; }
        window.__tovTrivetPending = true;
        addGiftProductToCart(TRIVET, 1, { _free_product: 'true', _product_id: 'order' })
          .then(function (added) { window.__tovTrivetPending = false; console.log('Untersetzer hinzugefügt:', added); })
          .catch(function () { window.__tovTrivetPending = false; });
      } else if (panLines.length === 0 && trivetLines.length > 0) {
        normalizeTrivet(0).then(function () { console.log('Untersetzer entfernt (keine Pfanne mehr).'); });
      } else if (panLines.length > 0 && (trivetQty > 1 || trivetLines.length > 1)) {
        normalizeTrivet(1).then(function () { console.log('Untersetzer auf genau 1 normalisiert.'); });
      }
    })();

    // TOVARA: Glasdeckel-Abgleich zentral bei JEDER Warenkorb-Aenderung (checkFreeGifts laeuft auf
    // jedem cart:refresh). Damit ist normalizeGlasdeckel die einzige Wahrheitsquelle fuer die
    // Deckelmenge und faengt auch die Wege ab, die der Per-Klick-Abgleich in theme.js nicht sieht
    // (getippte Menge, Entfernen der letzten Pfanne, Alt-Warenkorb).
    normalizeGlasdeckel();

    (function(){
      // TOVARA: animate the free-shipping bar only on first render; on re-renders
      // (add/remove) set it instantly so it never replays the fill-from-zero "reload".
      var _bar = document.getElementById("counterInput");
      if (_bar) {
        if (window.__tovBarAnimated) { _bar.value = parseInt(_bar.dataset.value) || 0; }
        else { window.__tovBarAnimated = true; animateCounter(_bar, 2000); }
      }
    })();  
    
    console.log('Data Product Values:', dataProductValues);
    console.log('html', freeGiftCircles);

    // TOVARA: persistent countdown — keep the deadline + a single interval in window
    // scope and re-query the element each tick, so add/remove never resets it to the
    // start value or stacks orphaned intervals. Update immediately so the freshly
    // re-rendered element shows the right time at once (no start-value flash).
    if (!window.__tovCountdownEnd) { window.__tovCountdownEnd = Date.now() + 5 * 60 * 1000; }
    function tovCountdownTick() {
      var el = document.getElementById("countdown");
      var greenBox = document.getElementById("countdownBox");
      var redBox = document.getElementById("countdown_redBox");
      var left = Math.round((window.__tovCountdownEnd - Date.now()) / 1000);
      if (left < 0) left = 0;
      var m = Math.floor(left / 60), sec = left % 60;
      if (el) { el.textContent = String(m).padStart(2, "0") + ":" + String(sec).padStart(2, "0"); }
      if (left <= 0) {
        if (window.__tovCountdownTimer) { clearInterval(window.__tovCountdownTimer); window.__tovCountdownTimer = null; }
        if (greenBox) { greenBox.style.display = "none"; }
        if (redBox) { redBox.style.display = "flex"; }
      }
    }
    tovCountdownTick();
    if (!window.__tovCountdownTimer && (window.__tovCountdownEnd - Date.now()) > 0) {
      window.__tovCountdownTimer = setInterval(tovCountdownTick, 1000);
    }


    if (activeCircle) {
        const productData = activeCircle.getAttribute('data-product');
        console.log('Found an active element with data-product:', productData);

        const matchingCartItem = Array.from(cartProductItems).find(item => 
            item.getAttribute('data-variant') === productData
        );

        if (matchingCartItem) {
            console.log('A matching cart item with data-variant:', productData, 'was found.');
        } else {
            console.log('No matching cart item with data-variant:', productData, 'was found.');
            addGiftProductToCart(productData, 1).then((added) => {
                console.log('Added: ', added);
            });
        }
    } else {
        const matchingCartItems = Array.from(cartProductItems).filter(item =>
            dataProductValues.includes(item.getAttribute('data-variant'))
        );

        if (matchingCartItems.length > 0) {
            console.log('Matching cart items found:', matchingCartItems);
            matchingCartItems.forEach(item => {
                item.closest('.line-item__info').querySelector('.line-item__remove-button').click();
            });          
        } else {
            console.log('No matching cart items found.');
        }
    }
};

// TOVARA: Auf der /cart-Seite laufen Mengen- und Entfernen-Aktionen als volle Navigation
// (_updateFromLink macht bei pageType 'cart' ein window.location.href). Dort feuert also kein
// cart:refresh und damit auch kein checkFreeGifts. Deshalb den Glasdeckel-Abgleich beim Laden
// der Cart-Seite einmal anstossen; nur wenn er wirklich korrigiert hat, einmal neu laden, damit
// die angezeigte Zeile zum Serverstand passt.
// Reload-Schleifen sind hart ausgeschlossen: ein Zaehler im sessionStorage erlaubt maximal
// TOV_MAX_RELOADS Korrektur-Reloads am Stueck und wird bei jedem bereits stimmigen Laden wieder
// auf 0 gesetzt. Selbst wenn der Abgleich wider Erwarten nie konvergiert (z.B. weil Shopify die
// Menge deckelt), steht die Seite nach drei Reloads still — der Serverstand ist dann trotzdem
// so korrekt, wie er sein kann.
document.addEventListener('DOMContentLoaded', function () {
  var TOV_MAX_RELOADS = 3;
  var isCartPage = false;
  try {
    isCartPage = !!(window.themeVariables && window.themeVariables.settings &&
                    window.themeVariables.settings.pageType === 'cart');
  } catch (e) {}
  if (!isCartPage) { return; }
  normalizeGlasdeckel().then(function (result) {
    try {
      if (result !== 'changed') { sessionStorage.setItem('tovGlasdeckelReloads', '0'); return; }
      var n = parseInt(sessionStorage.getItem('tovGlasdeckelReloads') || '0', 10) || 0;
      if (n >= TOV_MAX_RELOADS) { console.warn('Glasdeckel-Abgleich: Reload-Limit erreicht, Anzeige bleibt veraltet.'); return; }
      sessionStorage.setItem('tovGlasdeckelReloads', String(n + 1));
      window.location.reload();
    } catch (e) {}
  });
});
